const PAGE_CONTAINER_SELECTOR =
  ".page-sidebar-fixed.page-container.page-content-full-height, .page-content-full-height";

const PROVIDER_LIST_HEADER_ID = "topMenuHeader";
const PROVIDER_LIST_SCROLL_GAP = 8;

const getPageContainer = () => document.querySelector(PAGE_CONTAINER_SELECTOR);

const getWindowScrollPosition = () =>
  window.pageYOffset ||
  document.documentElement.scrollTop ||
  document.body.scrollTop ||
  0;

const pageContainerScrolls = (pageContainer) =>
  !!pageContainer && pageContainer.scrollHeight > pageContainer.clientHeight;

const getProviderListHeaderOffset = () => {
  const header = document.getElementById(PROVIDER_LIST_HEADER_ID);
  return (header?.offsetHeight ?? 0) + PROVIDER_LIST_SCROLL_GAP;
};

const applyHomeScrollPosition = (
  scrollTop,
  behavior = "auto",
  { pageContainer = getPageContainer(), includePageContainer = true } = {}
) => {
  const top = Math.max(0, Number(scrollTop) || 0);
  const scrollBehavior = behavior === "smooth" ? "smooth" : "auto";
  const opts = { top, behavior: scrollBehavior };

  try {
    if (includePageContainer && pageContainer) {
      pageContainer.scrollTo(opts);
    }

    window.scrollTo(opts);

    const docRoot = document.scrollingElement;
    if (docRoot) {
      docRoot.scrollTop = top;
    }
  } catch (e) {
    if (includePageContainer && pageContainer) {
      pageContainer.scrollTop = top;
    }

    window.scrollTo(0, top);

    const docRoot = document.scrollingElement;
    if (docRoot) {
      docRoot.scrollTop = top;
    }
  }
};

/**
 * Scroll restore is scoped to:
 * ProviderList (game click) -> DefaultLobby -> DefaultLobby back button only.
 */
export const isOpenedFromProviderList = (locationState) =>
  locationState?.openedFromProviderList === true;

export const shouldRestoreProviderListScroll = (locationState) =>
  locationState?.restoreProviderListScroll === true &&
  locationState?.providerListScrollTop != null;

export const getHomeScrollPosition = () => {
  const pageContainer = getPageContainer();
  const windowScroll = getWindowScrollPosition();

  if (!pageContainer) {
    return windowScroll;
  }

  if (pageContainerScrolls(pageContainer)) {
    return Math.max(pageContainer.scrollTop, windowScroll);
  }

  return windowScroll;
};

export const restoreHomeScrollPosition = (scrollTop, behavior = "auto") => {
  applyHomeScrollPosition(scrollTop, behavior);
};

export const scrollProviderListToTop = (section, behavior = "smooth") => {
  if (!section) return;

  const pageContainer = getPageContainer();
  const headerOffset = getProviderListHeaderOffset();
  const usePageContainer =
    pageContainer &&
    pageContainer.contains(section) &&
    pageContainerScrolls(pageContainer);

  const top = usePageContainer
    ? pageContainer.scrollTop +
      section.getBoundingClientRect().top -
      pageContainer.getBoundingClientRect().top -
      headerOffset
    : section.getBoundingClientRect().top + window.pageYOffset - headerOffset;

  applyHomeScrollPosition(top, behavior, {
    pageContainer,
    includePageContainer: usePageContainer,
  });
};

export const scheduleHomeScrollRestore = (scrollTop, delays = [0, 150, 400, 800, 1200, 2000]) => {
  if (scrollTop == null) {
    return () => {};
  }

  const timers = delays.map((delay) =>
    setTimeout(() => restoreHomeScrollPosition(scrollTop, "auto"), delay)
  );

  return () => {
    timers.forEach(clearTimeout);
  };
};
